enum WebinarActionTypes {
	CREATE_WEBINAR = "CREATE_WEBINAR",
	GET_WEBINAR = "GET_WEBINAR",
	GET_ALL_WEBINARS = "GET_ALL_WEBINARS",
	SET_WEBINAR_ID = "SET_WEBINAR_ID",
	GET_DELETED_WEBINARS = "GET_DELETED_WEBINARS",
	SET_WEBINAR_ERROR = "SET_WEBINAR_ERROR",
	UPDATE_WEBINAR = "UPDATE_WEBINAR",
	DELETE_WEBINAR = "DELETE_WEBINAR",
}

export default WebinarActionTypes;
